import { render, staticRenderFns } from "./BalladeService.vue?vue&type=template&id=3dc73650"
import script from "./BalladeService.vue?vue&type=script&lang=ts"
export * from "./BalladeService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports